<template>
  <ul class="app-list">
    <li v-for="(item, idx) in items" :key="idx" class="app-list__item">
      <slot name="item-content" :currentItem="item" :currentIndex="idx" :items="items" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AppList',

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.app-list__item:not(:first-of-type) {
  margin-top: 20px;
  margin-bottom: 0;
}
</style>
